import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { api } from "@/lib/api";
import { JujuModal } from "@/components/JujuModal";

const SIZES = ["XS", "S", "M", "L", "XL", "XXL", "CUSTOM"];

export const PreorderForm = ({ onSubmitted }) => {
  const navigate = useNavigate();
  const [form, setForm] = useState({ full_name: "", instagram: "", size: "" });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [showModal, setShowModal] = useState(false);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.full_name.trim() || !form.instagram.trim() || !form.size) {
      setError("Fill in your name, Instagram and size to lock in the Juju.");
      return;
    }
    setError("");
    setLoading(true);
    try {
      await api.post("/preorder", form);
      setSubmitted(true);
      setShowModal(true);
      onSubmitted?.();
    } catch {
      setError("Something glitched — try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <motion.div
      id="preorder"
      data-testid="preorder-form"
      className="glass-card mx-auto w-full max-w-xl scroll-mt-28 rounded-3xl p-6 sm:p-8"
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.5, duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
    >
      <h2 className="juju-heading mb-6 text-center text-xs sm:text-sm">
        Pre-Order
      </h2>
      <form onSubmit={submit} className="space-y-4">
        <input
          data-testid="preorder-name-input"
          className="juju-input"
          placeholder="Full Name"
          value={form.full_name}
          onChange={set("full_name")}
        />
        <input
          data-testid="preorder-instagram-input"
          className="juju-input"
          placeholder="Instagram — @yourhandle"
          value={form.instagram}
          onChange={set("instagram")}
        />
        <select
          data-testid="preorder-size-select"
          className="juju-input"
          value={form.size}
          onChange={set("size")}
        >
          <option value="" disabled>
            Select your size
          </option>
          {SIZES.map((s) => (
            <option key={s} value={s}>
              {s}
            </option>
          ))}
        </select>
        {error && (
          <p data-testid="preorder-error" className="text-sm text-rose-600">
            {error}
          </p>
        )}
        <div className="flex flex-col gap-3 pt-2 sm:flex-row">
          <button
            type="submit"
            data-testid="preorder-submit-btn"
            disabled={loading || submitted}
            className="btn-chrome flex-1 px-6 py-4 text-sm disabled:opacity-70"
          >
            {submitted ? "Submitted" : loading ? "Sending..." : "Submit Pre-Order"}
          </button>
          <button
            type="button"
            data-testid="do-you-want-good-juju-btn"
            onClick={() => navigate("/model")}
            className="btn-ghost-chrome flex-1 px-6 py-4 text-sm font-semibold"
          >
            Do you want Good Juju?
          </button>
        </div>
      </form>
      <JujuModal
        open={showModal}
        onClose={() => setShowModal(false)}
        title="Submitted"
        message="Good, Juju will be in touch ;)"
        popupTestId="preorder-success-popup"
        messageTestId="preorder-popup-message"
      />
    </motion.div>
  );
};
